export const formats = {
  date: "DD.MM.YYYY",
  datetime : "DD.MM.YYYY HH:mm:ss",
  supported_date_formats: [ 'DD.MM HH','DD.MM.YYYY', 'DD.MM.YYYY HH:mm', 'DD.MM.YY HH:mm', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm' ],
}
